import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Constants } from '@shared/constants/constants';
import Configs from '@shared/constants/configs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Company } from '@shared/enums/company';
import { AuthService } from '@core/auth/auth.service';
import { UserService } from '@routes/users/shared/user.service';
import Roles from '@shared/constants/roles';
import Utils from '@shared/utils/utils';
import { ZipCodeEditComponent } from '@routes/b2b/zip-code-list/zip-code-edit/zip-code-edit.component';
import { DealerApi } from '@shared/apis/dealer.api';

@Component({
  selector: 'app-zip-code-detail',
  templateUrl: './zip-code-detail.component.html',
  styleUrls: ['./zip-code-detail.component.scss']
})
export class ZipCodeDetailComponent implements OnInit {

  readonly constants = Constants;
  readonly color = Configs.badgeColor;
  isAdmin = false;
  query: any;
  q: any;
  options = { autoHide: true, scrollbarMaxSize: 100 };
  bsModalRef: BsModalRef;
  zipCodeDetail: any = {};
  roles;
  @Output() detailUpdateEvent = new EventEmitter();
  isEditable = false;
  company;
  userType = Constants.userType;
  companies = Company;
  storeList;
  isEmpty = false;

  constructor(
    private modalService: BsModalService,
    private authService: AuthService,
    private userService: UserService,
    private dealerApiService: DealerApi,
  ) {
    this.isAdmin = this.authService.hasType(Roles.b2bAdmins);
    this.company = this.authService.getCurrentCompany();
  }

  @Input() set zipCodeInfo(value) {
    if (!Utils.isEmpty(value)) {
      this.zipCodeDetail = value;
      this.getDealers(value);
    }
  }

  ngOnInit(): void {
    this.isEditable = this.isAdmin;
    this.userService.detailReload$.subscribe(res => {
      if (res) {
        this.detailUpdateEvent.emit('detailReload');
      }
    });
  }

  modalOpen() {
    const initialState = {
      title: 'Zip Code Edit', zipCodeInfo: this.zipCodeDetail
    };
    this.bsModalRef = this.modalService.show(ZipCodeEditComponent, {
      initialState,
      class: 'modal-lg',
      ignoreBackdropClick: true
    });
    this.bsModalRef.content.onClose.subscribe(result => {
      if (result) {
        this.detailUpdateEvent.emit(result)
      }
    });
  }

  getDealers(value) {
    this.dealerApiService.getDealersByZipCode(value.zipcode).subscribe(
      res => {
        this.storeList = res
        this.isEmpty = this.storeList.length < 1;
      }
    )
  }
}
